<template>

    <form @submit.prevent="validateForm('login-form')" data-vv-scope="login-form">
        <h2 class="p-login__title">Zaloguj się</h2>

        <form-input
            v-model="email"
            label="Email"
            v-validate.disable="'required|email'">
        </form-input>

        <form-input
            v-model="password"
            label="Hasło"
            type="password"
            data-vv-as="hasło"
            v-validate.disable="'required'">
        </form-input>

        <form-row align="center">
            <v-btn
                class="p-login__btn"
                :loading="isLoading"
                has-loader
                role="submit"
                type="green">
                Zaloguj się
            </v-btn>
        </form-row>
        <form-desc class="p-login__forgot">
            <router-link :to="{ name: 'ResetPassword', query: { email: email} }">Nie pamiętam hasła</router-link>
        </form-desc>
    </form>

</template>


<script>

import {FormInput, FormRow, FormDesc} from 'Components/Form'
import VBtn from 'Components/VBtn'

export default {

    name: 'ViewLogin',

    props: ['loginToken'],

    data() {
        return {
            email: this.$route.query.email || '',
            password: '',
            rememberMe: false,
            isLoading: false
        }
    },

    methods: {
        validateForm(scope) {
            this.isLoading = true

            this.$validator.validateAll(scope).then((result) => {
                if (result) {
                    this.$auth.login({
                        params: {
                            email: this.email,
                            password: this.password,
                            remember_me: this.rememberMe ? '1' : '0'
                        },
                        error: function (error) {
                            this.isLoading = false
                            this.$alert.error('Błąd logowania', error.response.data.message)
                            this.password = null
                            this.$validator.reset()
                        },
                        rememberMe: this.rememberMe
                    })
                } else {
                    this.isLoading = false
                }
            })
        },
        loginWithToken(loginToken) {
            this.$auth.login({
                data: {
                    login_token: loginToken
                },
            }).catch(error => {
                this.$router.push({ name: 'Login' });
                if (error.response && error.response.status === 401) {
                    this.$alert.error('Błąd logowania', error.response.data.message)
                } else {
                    console.error(error);
                }
            });
        }
    },

    async created() {
        if (this.loginToken) {
            let loginToken = this.loginToken;
            if (this.$auth.check()) {
                await this.$auth.logout({
                    redirect: false,
                    success() {
                        this.loginWithToken(loginToken)
                    },
                });
            } else {
                this.loginWithToken(this.loginToken)
            }
        }
    },

    components: {
        FormInput,
        FormRow,
        FormDesc,
        VBtn,
    }

}

</script>


<style lang="scss">

@import '~Style/_utils.scss';

.p-login {
    &__title {
        margin-bottom: 25px;
    }
    &__btn a {
        font-size: 16px;
    }
    &__forgot {
        margin: 0;
        margin-top: 2em;
        text-align: center;
    }
}

</style>
